import React from "react";
import PropTypes from "prop-types";
import LogoWhite from "../../assets/img/logo-white.png";
import {Link} from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import LockOutline from "@material-ui/icons/LockOutlined";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import {request} from "../../api-client";
import localization from "../../config/localization";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../components/Letflow/Snackbar/GlobalSnackbar";
import queryString from 'querystring'
import {Instagram, Language, Person} from "@material-ui/icons";
import './register.css'
import availableLanguages from '../../config/localization/availableLanguages.json'
import {MenuItem, Select} from "@material-ui/core";

class Register extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      keepLogged: "keep",
      username: "",
      language: "es"
    };
  }

  componentDidMount() {
    document.title = localization.get('register') + ' - Bloomclouds'
    this.setState({
      username: queryString.parse(queryString.parse(this.props.location.search)['?url'].split("?")[1])['email'] || "",
      language: queryString.parse(queryString.parse(this.props.location.search)['?url'].split("?")[1])['lang'] || "es"
    }, () => {
      if (!localStorage.getItem("default_language") || localStorage.getItem("default_language") !==this.state.language) {
        localStorage.setItem("default_language", this.state.language);
        localization.setLanguage(this.state.language);
        window.location.reload()
      }

      localStorage.setItem("default_language", this.state.language);
      localization.setLanguage(this.state.language);
    })
  }

  register = () => {
    if(this.state.username && this.state.name && this.state.password && this.state.password === this.state.confirmPassword && this.state.password.length > 5) {
      this.setState({ requesting: true })
      request.authentication.talentUserRegister({url: queryString.parse(this.props.location.search)['?url'], name: this.state.name, email: this.state.username ,password: this.state.password, lang: this.state.language })
        .then(() => {
          this.setState({ requesting: false })
          GlobalSnackbar.show({
            message: localization.get("login.register_complete_public"),
            type: GlobalSnackbarTypes.SUCCESS,
          })

          request.authentication.login({username: this.state.username, password: this.state.password})
            .then(() => setTimeout(() =>  window.location.href = "/", 1000))
        })
        .catch(e => {
          this.setState({ requesting: false })
          GlobalSnackbar.show({
            message: e.status == 406  ? localization.get('login.channel_already_register') : localization.get('login.login_failed'),
            type: GlobalSnackbarTypes.ERROR,
          })
        })
    }else {
      GlobalSnackbar.show({
        message:  (!this.state.username) ? localization.get('login.error_username_required')
          : !this.state.name ? localization.get('login.error_name_required')
          : !this.state.password ? localization.get('login.error_password_required')
          : this.state.password !== this.state.confirmPassword ? localization.get('login.error_password_not_match')
          : this.state.password.length < 5 ? localization.get('login.error_password_too_short') : "error",
        type: GlobalSnackbarTypes.ERROR,
      })
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.content} style={{minHeight: "100vh", backgroundColor: "#7f7f7f"}}>
          <div className={"transparent-register-banner"}>
            <div style={{ flexGrow:1}}>
              <Link to="https://www.bloomclouds.com" target={"_blank"}>
                <img style={{ height: 35, flexGrow:1}} src={LogoWhite} alt="Logo Bloomclouds"/>
              </Link>
            </div>
            <div className={"banner-text"}>
              <p>{localization.get('bloomclouds.slogan')}</p>
            </div>
            <div className={"side-navbar"}>
              <Link to="https://www.instagram.com/bloomclouds" target={"_blank"}> <Instagram/> </Link>
              <Link to="https://www.bloomclouds.com" target={"_blank"}> <Language/> </Link>
              <Link to="/login" style={{padding: "12px 10px", fontSize: 16}}>Login</Link>
            </div>
          </div>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={6} md={6}>
                <form>
                  <Card register style={{opacity: "1!important", padding: "40px 60px"}}>
                    <h3 style={{textAlign: "center"}}>{localization.get('form.register.title')}</h3>
                    <CardBody>
                      <CustomInput
                        labelText={localization.get("form.name")}
                        id="name"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Person className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: e => this.setState({ name: e.target.value })
                        }}
                      />
                      <CustomInput
                        labelText="Email"
                        id="username"
                        disabled={true}
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          value: this.state.username,
                          disabled: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <Email className={classes.inputAdornmentIcon} />
                            </InputAdornment>
                          ),
                          onChange: e => this.setState({ username: e.target.value })
                        }}
                      />
                      <CustomInput
                        labelText={localization.get('password')}
                        id="password"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutline
                                className={classes.inputAdornmentIcon}
                              />
                            </InputAdornment>
                          ),
                          onChange: e => this.setState({ password: e.target.value }),
                          type: 'password',
                          onKeyPress: e => {
                            if (e.key === 'Enter') {
                              e.preventDefault()
                              this.register()
                            }
                          }
                        }}
                      />
                      <CustomInput
                        labelText={localization.get('repeat_password')}
                        id="confirmPassword"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LockOutline
                                className={classes.inputAdornmentIcon}
                              />
                            </InputAdornment>
                          ),
                          onChange: e => this.setState({ confirmPassword: e.target.value }),
                          type: 'password',
                          onKeyPress: e => {
                            if (e.key === 'Enter') {
                              e.preventDefault()
                              this.register()
                            }
                          }
                        }}
                      />
                      <span>{localization.get('form.language')}</span>
                      <Select
                        style={{width: "100%", marginBottom: 15}}
                        onChange={event => this.setState({ language: event.target.value })}
                        value={this.state.language}
                      >
                        {availableLanguages.map(lang => <MenuItem value={lang} >{localization.get(`language.${lang}`)}</MenuItem> )}
                      </Select>
                    </CardBody>
                    <CardFooter className={classes.justifyContentCenter}>
                      <Button onClick={this.register} color="default" style={{ backgroundColor: "black", maxWidth: 175, borderRadius: 5, fontWeight: "bold", marginTop: 15 }} simple block disabled={this.state.requesting}>{localization.get('register')}</Button>
                    </CardFooter>
                  </Card>
                </form>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </React.Fragment>
    )
      ;
  }
}

Register.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(Register);
